(function () {
let domCheck;
const doDomCheck = function(){
  
  el1 = document.querySelector('.varified-wrapper');
  if(el1 && screen && screen.width < 768){
  clearInterval (domCheck);    
    var varifiedElements = document.querySelectorAll(".single-product-section .single-prod-wrapper .single-prod-col .varified-wrapper");
    
    var destinationElement = document.querySelector(".single-product-section .single-prod-wrapper .single-prod-content .inner-single-prod-col");
    
    varifiedElements.forEach(function(varifiedElement) {
        destinationElement.appendChild(varifiedElement);
    });
  }
}
domCheck = setInterval(doDomCheck,200);
})();

// 
const swiperPDP = new Swiper(".hp_blog_posts_wrapper .swiper-container", {
  centeredSlides: false,
  slidesPerView: 3,
  loop: true,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }
});

if (screen && screen.width > 767) {
  const swiper1 = new Swiper(".most_popular_products_wrapper .swiper-container", {
    centeredSlides: false,
    slidesPerView: 4,  
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0: {
        slidesPerView: 2
      },
      640: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 4
      }
    }
  });
}


const swiper2 = new Swiper(".hp_5star_members_wrapper .swiper-container", {
  centeredSlides: false,
  slidesPerView: 4,  
  loop: true,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    640: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 4
    }
  }
});

const doctorsSlider = new Swiper(".hp_doctors_wrapper .swiper-container", {
  centeredSlides: false,
  slidesPerView: 4,  
  loop: true,
  // Improve stability and pagination sync in loop mode
  normalizeSlideIndex: true,
  watchSlidesProgress: true,
  observer: true,
  observeParents: true,
  spaceBetween: 20,
  autoplay: {
    delay: 2500,
    // Stop autoplay after any user interaction (click, swipe, drag)
    disableOnInteraction: true,
  },
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: false,
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  on: {
    slideChange: function () {
      if (this.pagination && this.pagination.update) {
        this.pagination.update();
      }
    },
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }
  }
});

// Explicitly stop autoplay on user interactions to ensure it doesn't resume
if (doctorsSlider && doctorsSlider.autoplay) {
  doctorsSlider.on('touchStart', function() {
    doctorsSlider.autoplay.stop();
  });
  doctorsSlider.on('sliderMove', function() {
    doctorsSlider.autoplay.stop();
  });
  const doctorsWrapper = document.querySelector('.hp_doctors_wrapper');
  if (doctorsWrapper) {
    const nextBtn = doctorsWrapper.querySelector('.swiper-button-next');
    const prevBtn = doctorsWrapper.querySelector('.swiper-button-prev');
    const paginationEl = doctorsWrapper.querySelector('.swiper-pagination');
    if (nextBtn) nextBtn.addEventListener('click', function() { doctorsSlider.autoplay.stop(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { doctorsSlider.autoplay.stop(); });
    if (paginationEl) paginationEl.addEventListener('click', function() { doctorsSlider.autoplay.stop(); });
  }
}

// Navigation elements
$('.hp_doctors_wrapper .swiper-pagination').appendTo('.hp_doctors_wrapper .next-prev-arrow');
$('.hp_doctors_wrapper .swiper-button-next').appendTo('.hp_doctors_wrapper .next-prev-arrow');
$('.hp_doctors_wrapper .swiper-button-prev').appendTo('.hp_doctors_wrapper .next-prev-arrow');

$('.hp_5star_members_wrapper .swiper-pagination').appendTo('.hp_5star_members_wrapper .next-prev-arrow');
$('.hp_5star_members_wrapper .swiper-button-next').appendTo('.hp_5star_members_wrapper .next-prev-arrow');
$('.hp_5star_members_wrapper .swiper-button-prev').appendTo('.hp_5star_members_wrapper .next-prev-arrow');

$('.hp_blog_posts_wrapper .swiper-pagination').appendTo('.hp_blog_posts_wrapper .next-prev-arrow');
$('.hp_blog_posts_wrapper .swiper-button-next').appendTo('.hp_blog_posts_wrapper .next-prev-arrow');
$('.hp_blog_posts_wrapper .swiper-button-prev').appendTo('.hp_blog_posts_wrapper .next-prev-arrow');


$('.most_popular_content_wrapper .most_popular_content_slider').each(function(){
    $(this).find('.swiper-pagination').appendTo($(this).find('.next-prev-arrow'));
    $(this).find('.swiper-button-next').appendTo($(this).find('.next-prev-arrow'));
    $(this).find('.swiper-button-prev').appendTo($(this).find('.next-prev-arrow'));
})



 


$(document).ready(function() {
    // Check if the window width is less than or equal to 767 pixels
    if ($(window).width() <= 767) {
        // Move the button on mobile screens
        //$('header button.btn--link.site-header__icon.js-mobile-nav-toggle').prependTo('header .grid.site-header__mobile-nav');
        
        // Initialize Swiper on mobile screens
        var swiper3 = new Swiper(".our-product .ingredients_content.swiper.mySwiper", {
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
            },
        });

    // Faq for mobile
      // .our-core-values .ingredients_content .content h4
      $('.our-core-values .ingredients_content .content h4').appendTo('.our-core-values .ingredients_content .image');
      $('.our-core-values .ingredients_content li:first-child .image.Que').addClass('active');
      $('.our-core-values .ingredients_content li:first-child .content').css('display','block');
        $(".our-core-values .set > .Que").on("click", function() {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this)
              .siblings(".our-core-values .content")
              .slideUp(200);
          } else {
            $(".our-core-values .set > .Que").removeClass("active");
            $(this).addClass("active");
            $(".our-core-values .content").slideUp(200);
            $(this)
              .siblings(".our-core-values .content")
              .slideDown(200);
          }
        });

      // footer faq
      $('.our-core-values .ingredients_content .content h4').appendTo('.our-core-values .ingredients_content .image');
        $("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list > p.h4").on("click", function() {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this)
              .siblings("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list ul.site-footer__linklist")
              .slideUp(200);
            $("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list > p.h4 i")
              .removeClass("fa-minus")
              .addClass("fa-plus");
          } else {
            $("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list > p.h4 i")
              .removeClass("fa-minus")
              .addClass("fa-plus");
            $(this)
              .find("i")
              .removeClass("fa-plus")
              .addClass("fa-minus");
            $("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list > p.h4").removeClass("active");
            $(this).addClass("active");
            $("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list ul.site-footer__linklist").slideUp(200);
            $(this)
              .siblings("footer.site-footer .page-width .site-footer__content .site-footer__item-inner.site-footer__item-inner--link_list ul.site-footer__linklist")
              .slideDown(200);
          }
        });

      // Footer append paragraph
      $('.site-footer .site-footer__content .site-footer__item:first-child p').appendTo('footer.site-footer .page-width .site-footer__content');
    }
});


// customer rating slider
var custRatingSlider = new Swiper(".customer-reviews-sec .customer-review-slider", {
  slidesPerView: 1,
  spaceBetween: 50,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 22,
      },
    },
});

// related product slider
var relatedProdSlider = new Swiper(".customer-reviews-sec .related-prod-slider", {
  slidesPerView: 1,
  spaceBetween: 50,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
  },
  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 22,
      },
    },
});

//  Home FAQ section
$(".faq-main-sec .set > a").on("click", function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this)
      .siblings(".faq-main-sec .content")
      .slideUp(200);
    $(".faq-main-sec .set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
  } else {
    $(".faq-main-sec .set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
    $(".faq-main-sec .set > a").removeClass("active");
    $(this).addClass("active");
    $(".faq-main-sec .content").slideUp(200);
    $(this)
      .siblings(".faq-main-sec .content")
      .slideDown(200);
  }
});


//  Home FAQ section
$(".prod-accordion-wrap .set > a").on("click", function() {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this)
      .siblings(".prod-accordion-wrap .content")
      .slideUp(200);
    $(".prod-accordion-wrap .set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
  } else {
    $(".prod-accordion-wrap .set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
    $(".prod-accordion-wrap .set > a").removeClass("active");
    $(this).addClass("active");
    $(".prod-accordion-wrap .content").slideUp(200);
    $(this)
      .siblings(".prod-accordion-wrap .content")
      .slideDown(200);
  }
});

var sliderThumbnail = new Swiper('.product-thumbs', {
  slidesPerView: 4,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var slider = new Swiper('.product-slider', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: sliderThumbnail
  }
});


if (screen && screen.width < 768) {
  var relatedProdSlider11 = new Swiper(".key-ingredients-wrapper .key-ingredients-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      }
    });
}